/* PM Moon: sidereal (Lahiri) Moon sign for a birth date and optional time, all in the browser.
   Series: truncated Meeus ch. 47 lunar longitude (27 terms plus 3 additive terms). Birth time is read as IST (UTC+5:30).
   API: PMMoon.at(y,m,d,hh,mi) -> {lon, idx}; PMMoon.day(y,m,d) -> {a, b, same, change}; idx 0=Mesh .. 11=Meen. */
(function(){
  if(window.PMMoon) return;
  var R=Math.PI/180;
  function jdUTC(y,m,d,h,mi){ /* Gregorian date + UTC clock to Julian Day */
    if(m<=2){y-=1;m+=12;}
    var A=Math.floor(y/100),B=2-A+Math.floor(A/4);
    return Math.floor(365.25*(y+4716))+Math.floor(30.6001*(m+1))+d+B-1524.5+(h+mi/60)/24;
  }
  function sidLon(jd){
    var T=(jd-2451545.0)/36525;
    var L=218.3164477+481267.88123421*T, D=297.8501921+445267.1114034*T, M=357.5291092+35999.0502909*T;
    var P=134.9633964+477198.8675055*T, F=93.2720950+483202.0175233*T;
    var E=1-0.002516*T-0.0000074*T*T;
    function s(x){return Math.sin(x*R);}
    var S=6.288774*s(P)+1.274027*s(2*D-P)+0.658314*s(2*D)+0.213618*s(2*P)-0.185116*E*s(M)-0.114332*s(2*F)
      +0.058793*s(2*D-2*P)+0.057066*E*s(2*D-M-P)+0.053322*s(2*D+P)+0.045758*E*s(2*D-M)-0.040923*E*s(M-P)-0.034720*s(D)
      -0.030383*E*s(M+P)+0.015327*s(2*D-2*F)-0.012528*s(P+2*F)+0.010980*s(P-2*F)+0.010675*s(4*D-P)+0.010034*s(3*P)
      +0.008548*s(4*D-2*P)-0.007888*E*s(2*D+M-P)-0.006766*E*s(2*D+M)-0.005163*s(D-P)+0.004987*E*s(D+M)+0.004036*E*s(2*D-M+P)
      +0.003994*s(2*P+2*D)+0.003861*s(4*D)+0.003665*s(2*D-3*P)
      +0.003958*s(119.75+131.849*T)+0.001962*s(L-F)+0.000318*s(53.09+479264.290*T);
    var trop=((L+S)%360+360)%360;
    /* Lahiri ayanamsa: 23.85306 deg at J2000, general precession 5028.796"/century */
    var ay=23.85306+(5028.796195*T+1.1054348*T*T)/3600;
    return ((trop-ay)%360+360)%360;
  }
  /* IST clock (y,m,d,hh,mi) -> JD. Uses UTC = IST - 5:30 */
  function jdIST(y,m,d,hh,mi){return jdUTC(y,m,d,hh,mi)-5.5/24;}
  function at(y,m,d,hh,mi){var l=sidLon(jdIST(y,m,d,hh||0,mi||0));return {lon:l,idx:Math.floor(l/30)%12};}
  function day(y,m,d){
    var a=at(y,m,d,0,0), b=at(y,m,d,23,59), r={a:a.idx,b:b.idx,same:a.idx===b.idx,change:null};
    if(!r.same){ /* bisection for the minute the sign changes (IST clock) */
      var lo=0,hi=1439;
      while(hi-lo>1){var mid=(lo+hi)>>1;if(at(y,m,d,Math.floor(mid/60),mid%60).idx===a.idx)lo=mid;else hi=mid;}
      r.change=('0'+Math.floor(hi/60)).slice(-2)+':'+('0'+(hi%60)).slice(-2);
    }
    return r;
  }
  window.PMMoon={at:at,day:day,lon:function(y,m,d,hh,mi){return at(y,m,d,hh,mi).lon;}};
})();